/**
 * @desc 根据交货单单号查询绑定的箱子
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<Array<defs.srm.SupplierBoxResponseDto>>;
export function request(dono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierBox/getBoxCodeByDono/${dono}`, {
      method: "GET",

      ...options,
    }),
  );
}
